/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_AddInputs */

const en_serve_add = /** @type {(inputs: Serve_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up on a new computer`)
};

const id_serve_add = /** @type {(inputs: Serve_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang di komputer baru`)
};

/**
* | output |
* | --- |
* | "Set up on a new computer" |
*
* @param {Serve_AddInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_add = /** @type {((inputs?: Serve_AddInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_AddInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_add(inputs)
	return en_serve_add(inputs)
});